import React, { useContext } from 'react';
import Checkbox from '../../checkbox/Checkbox';
import { CheckType, Column, Row } from '../component/types';
import { TableContext } from './provider/Provider';

interface Props<T> {
  row: T;
  index: number;
  column: Column<T>;
  check: CheckType;
}

function ColumnCheckItem<T extends Row>({ row, index, column }: Props<T>) {
  const { selectedColumnIdsData, onClickColumnCheckbox } =
    useContext(TableContext);

  return (
    <Checkbox
      id={`all[${row?.id || index}]-${column?.id}`}
      name={`all[${row?.id || index}]-${column?.id}`}
      controlling
      value={(row?.id || index) as string}
      checked={selectedColumnIdsData?.[
        column?.id?.toString()
      ]?.rowIds?.includes(row?.id.toString() || index.toString())}
      onChange={() =>
        onClickColumnCheckbox(
          column?.id.toString(),
          row?.id.toString() || index.toString(),
        )
      }
    />
  );
}

export default ColumnCheckItem;
